import { addDays } from 'date-fns';
import { useCallback } from 'react';
import { useEvent } from '~/components/Event/CheckIn/CheckIn.hooks';
import { T, t } from '~/components/I18n';
import checkBoard from '~/components/Icon/checkBoard.png';
import { useMember } from '~/components/Member/Member.hooks';
import { QuickMenuItem } from '~/components/Quick/Menu/QuickMenuItem';
import { sharedDateTimer, useCountdown } from '~/components/Util';
import styles from './CheckInQuickMenuItem.module.scss';

export const CheckInQuickMenuItem = () => {
  const {
    data: { isLoggedIn },
  } = useMember();
  const { data: checkInEvent } = useEvent('CHECK_IN', { useErrorBoundary: false });
  const { isJoinable = false } = checkInEvent || {};

  const resetTime = (() =>
    addDays(
      Date.UTC(
        sharedDateTimer.now.getUTCFullYear(),
        sharedDateTimer.now.getUTCMonth(),
        sharedDateTimer.now.getUTCDate(),
        0
      ),
      1
    ))();

  const { hours, minutes, seconds } = useCountdown(resetTime);

  const handleClick = useCallback(
    (event) => {
      if (isLoggedIn && !isJoinable) event.preventDefault();
    },
    [isJoinable, isLoggedIn]
  );

  return (
    <QuickMenuItem
      active={isLoggedIn && isJoinable}
      image={checkBoard}
      label={t('citizen_quick_attend')}
      description={
        isJoinable ? (
          <span className={styles.countdown}>{`${hours.toString().padStart(2, '0')}:${minutes
            .toString()
            .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`}</span>
        ) : (
          <T name="citizen_quick_attend_complete" />
        )
      }
      onClick={handleClick}
    />
  );
};
